<template>
  <v-autocomplete
    class="pulse-input pulse-autocomplete"
    outlined
    dense
    :hide-details="!hasErrors"
    :menu-props="{ offsetY: true, contentClass: 'pulse-select-menu' }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #append>
      <i class="pi pi-chevron-down pulse-input__icon" />
    </template>
    <template v-if="$scopedSlots.selection" #selection="slotProps">
      <slot name="selection" v-bind="slotProps" />
    </template>
    <template v-if="$scopedSlots.item" #item="slotProps">
      <slot name="item" v-bind="slotProps" />
    </template>
    <template v-if="$slots['no-data']" #no-data>
      <slot name="no-data" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "PulseAutocomplete",
  inheritAttrs: false,
  computed: {
    hasErrors() {
      const errors = this.$attrs["error-messages"];
      return Array.isArray(errors) ? errors.length > 0 : !!errors;
    },
  },
};
</script>
